import { Model, ModelData } from '../general'

export interface Data extends ModelData {
  name: string
  src: string
  width: number
  workspace_type_id: number
}

class WorkspaceTypeElement extends Model<Data> {
  get name() {
    return this.data.name
  }

  get src() {
    return this.data.src
  }

  get width() {
    return this.data.width
  }

  get workspaceTypeId() {
    return this.data.workspace_type_id
  }
}

export default WorkspaceTypeElement
